import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  styled,
  TextField,
  Typography
} from '@mui/material';

import useGenerationBody from './useGenerationBody';

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& label.Mui-focused': {
    color: theme.palette.text.primary
  },
  '& label.Mui-error': { color: theme.palette.text.primary },
  '& div.MuiInput-underline::after': {
    borderBottom: `2px solid ${theme.palette.text.primary}`
  }
}));

const PreGenerationBody = ({ handleClose }: { handleClose: () => void }) => {
  const { handleChange, apiKeyName, onGenerate, error, loading } = useGenerationBody();
  return (
    <>
      <DialogContent sx={{ paddingBottom: 2 }}>
        <Box sx={{ paddingTop: 2, display: 'flex', alignItems: 'flex-start' }}>
          <Typography
            sx={{ mr: 3, pt: 0.5 }}
            variant='subtitle2'
          >
            Name
          </Typography>
          <StyledTextField
            autoFocus
            autoComplete='off'
            disabled={loading}
            error={!!error}
            helperText={error}
            id='key-label'
            slotProps={{ htmlInput: { maxLength: 60 } }}
            value={apiKeyName}
            variant='standard'
            onChange={handleChange}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          sx={{ mr: 2, height: 48 }}
          variant='text'
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          disabled={!apiKeyName.length || loading || Boolean(error.length)}
          sx={{ height: 48 }}
          variant='contained'
          onClick={() => {
            onGenerate();
          }}
        >
          Generate
        </Button>
      </DialogActions>
    </>
  );
};

export default PreGenerationBody;
